import { httpCreate } from './http';

const http = httpCreate('/shop/api/resell-product');

export const resellProduct = {
	//后台获取直播商品列表
	getresellProduct(type, params) {
		return http.get(`/${type}/list`, { params });
	},
	//后台设置佣金
	commission(data) {
		return http.put('/commission', data);
	},
	getCommissionSetting(id, activtyType) {
		return http.get(`${id}/commissionSetting/${activtyType}`);
	},
};
